export default __webpack_public_path__ + "static/media/img_muslinTwoBunnyEarsBib_yg.7bb2ecd6.jpg";